module.exports = __webpack_public_path__ + "static/img/02.f8474a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/about/02.jpg
// module id = 22
// module chunks = 0